import { render, staticRenderFns } from "./SoftwareComponentLoginAdd.vue?vue&type=template&id=65cd978a&scoped=true&"
import script from "./SoftwareComponentLoginAdd.vue?vue&type=script&lang=js&"
export * from "./SoftwareComponentLoginAdd.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareComponentLoginAdd.vue?vue&type=style&index=0&id=65cd978a&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cd978a",
  null
  
)

export default component.exports